import { render } from "./OwnerTypeEditView.vue?vue&type=template&id=25d21d4f&scoped=true"
import script from "./OwnerTypeEditView.vue?vue&type=script&lang=js"
export * from "./OwnerTypeEditView.vue?vue&type=script&lang=js"

import "./OwnerTypeEditView.vue?vue&type=style&index=0&id=25d21d4f&scoped=true&lang=css"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/manage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d21d4f"]])

export default __exports__